import { render, staticRenderFns } from "./PaymentDurationMip.vue?vue&type=template&id=5af41dc8&"
import script from "./PaymentDurationMip.vue?vue&type=script&lang=js&"
export * from "./PaymentDurationMip.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDurationMip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports